import * as React from 'react'

import { Box, Button, ModalDialogType } from '@factorialco/deprecated-design-system'

import Dialog from 'modules/core/components/Modal/Dialog'
import i18n from 'modules/core/lib/i18n'

interface ResetFormProps {
  onCancel: () => void
  onConfirm: () => void
}

export const ResetModalForm: React.FC<ResetFormProps> = ({ onCancel, onConfirm }) => {
  const footer = React.useMemo(
    () => (
      <Box flexDirection="row" gap="s12" justifyContent="flexEnd">
        <Button type="secondary" onClick={onCancel}>
          {i18n.t('add_employee_modal.devices_step.cancel_button')}
        </Button>
        <Button onClick={onConfirm}>
          {i18n.t('add_employee_modal.devices_step.reset_button')}
        </Button>
      </Box>
    ),
    [onCancel, onConfirm]
  )

  return (
    <Dialog
      type={ModalDialogType.Regular}
      title={i18n.t('add_employee_modal.devices_step.reset_confirmation_title')}
      description={i18n.t('add_employee_modal.devices_step.reset_confirmation_description')}
      footer={footer}
      locked
    />
  )
}
